/**
 * Metadata de ativação condicional das seções de Crédito Presumido (IBS/CBS)
 * conforme o código escolhido (cCredPres, catálogo codigo_cred_pres, Anexo IV
 * da LC 214/2025). Substitui a leitura de um indicador que nunca existiu no
 * banco (coluna `indicadores` sempre NULL) - mesmo padrão dos metadata de
 * CST/CSOSN da Natureza de Operação: a decisão fica no front, ajustável sem
 * migration.
 *
 * Postura pouco restritiva: os 5 códigos do Anexo IV concedem crédito
 * presumido nos dois tributos, então o default liga IBS e CBS; o usuário
 * pode desligar manualmente qualquer um dos dois.
 */
export interface CodigoCreditoPresumidoMeta {
    ativarIbs: boolean;
    ativarCbs: boolean;
}

const DEFAULT_META: CodigoCreditoPresumidoMeta = { ativarIbs: true, ativarCbs: true };

export function getCodigoCreditoPresumidoMeta(codigo: string | null | undefined): CodigoCreditoPresumidoMeta | null {
    if (!codigo) return null;
    // Os 5 códigos vigentes do Anexo IV concedem crédito presumido nos dois tributos.
    return { ...DEFAULT_META };
}
